import { api } from './api';

export async function enableEventPush() {
  if (!window.isSecureContext || !('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) {
    throw new Error('Push notifications are not supported here. In-app reminders remain available.');
  }
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') throw new Error('Browser notifications were not allowed. Your in-app reminders will still work.');
  await navigator.serviceWorker.register('/sw.js');
  const ready = await navigator.serviceWorker.ready;
  const { publicKey } = await api('/push/vapid-public-key');
  const padding = '='.repeat((4 - publicKey.length % 4) % 4);
  const bytes = Uint8Array.from(atob((publicKey + padding).replace(/-/g, '+').replace(/_/g, '/')), c => c.charCodeAt(0));
  const subscription = await ready.pushManager.getSubscription() || await ready.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: bytes });
  const json = subscription.toJSON();
  await api('/push/subscribe', { method: 'POST', body: JSON.stringify({ endpoint: json.endpoint, p256dh: json.keys.p256dh, auth: json.keys.auth }) });
  return true;
}